/* global __APP_VERSION__ */
import '../createPassword/index.scss';
import ForgotPassword from '../forgotPassword';
import React from 'react';
import { connect } from 'react-redux';
interface UserActivatedProps {
  socket?: any;
}

interface UserActivatedState {
  showForgot: boolean;
}

const mapStateToProps = (store: any) => ({
  socket: store.socket.container,
});

class UserActivated extends React.Component<
  UserActivatedProps,
  UserActivatedState
> {
  constructor(props: UserActivatedProps) {
    super(props);
    this.state = { showForgot: false };
    this.handleShowForgot = this.handleShowForgot.bind(this);
    this.handleCloseForgot = this.handleCloseForgot.bind(this);
  }

  back() {
    window.location.replace('/');
  }

  handleShowForgot(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    e.preventDefault();
    this.setState({ showForgot: true });
  }

  handleCloseForgot() {
    this.setState({ showForgot: false });
  }

  render() {
    return (
      <div
        className="login"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f5f5f5',
          position: 'relative',
        }}
      >
        <div
          className="form-signin"
          style={{
            margin: 'auto',
            width: '100%',
            maxWidth: 700,
            boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
            borderRadius: 12,
            background: '#fff',
            zIndex: 1,
          }}
        >
          <div
            className="border-top"
            style={{
              width: '100%',
              height: 6,
              background: 'linear-gradient(270deg, #3CBDEB 0%, #5081FF 100%)',
              borderRadius: '12px 12px 0 0',
            }}
          ></div>
          <div
            className="logo logo-header"
            style={{ maxWidth: '100%', padding: 24, textAlign: 'center' }}
          >
            <img
              src="/images/cloudcfo-logo-colored-icon-beside-text.png"
              className="img-responsive"
              style={{ height: '36px', margin: '0 auto', display: 'block' }}
            />
            <h1 className="" style={{ marginTop: 16, fontWeight: 500 }}>
              Link expired or invalid
            </h1>
            {/* <a className="btn btn-lg btn-violet btn-block mt20" onClick={() => this.back()}>Back</a> */}
          </div>
          <div
            className="activationLinkNote text-center"
            style={{ textAlign: 'center' }}
          >
            <div
              className="mb50 text-black"
              style={{ fontSize: '18px', lineHeight: '37px', marginBottom: 72 }}
            >
              <p>It looks like this activation link is no longer valid.</p>
              <p>Contact your CloudCFO administrator for assistance. </p>
              <p>or </p>
              Submit a ticket through our{' '}
              <a
                href="https://www.notion.so/cloudcfoph/278db69b4c2d8030b354f2ef567de446?pvs=106"
                target="_blank"
              >
                Helpdesk
              </a>{' '}
            </div>
            <div>
              <span
                style={{ color: '#999999', fontSize: '18px' }}
              >{`App version: ${__APP_VERSION__}`}</span>
            </div>
          </div>
        </div>
        {this.state.showForgot && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.35)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                position: 'relative',
                zIndex: 10000,
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
                padding: 0,
              }}
            >
              <ForgotPassword
                type={'client'}
                onClose={this.handleCloseForgot}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(UserActivated);
